export const paymentTrackIDs = {
    stepUp: 'dagligbank-lokalbank-step-up',
    actionButton: 'dagligbank-lokalbank-action-button',
    recurring: {
        paymentName: 'dagligbank-lokalbank-recurring-payment',
        transferName: 'dagligbank-lokalbank-recurring-transfer',
        agreement: 'dagligbank-lokalbank-recurring-agreement',
        update: 'dagligbank-lokalbank-recurring-update',
        delete: 'dagligbank-lokalbank-recurring-delete',
        bsu: 'dagligbank-lokalbank-recurring-bsu',
    },
    avtalegiro: {
        avtalegiroName: 'dagligbank-avtalegiro-details',
        agreement: 'dagligbank-lokalbank-avtalegiro-agreement',
        delete: 'dagligbank-lokalbank-avtalegiro-delete',
        update: 'dagligbank-lokalbank-avtalegiro-update',
        proposalName: 'dagligbank-avtalegiro-proposal-details',
        proposalAgreement: 'dagligbank-lokalbank-avtalegiro-proposal-agreement',
        proposalDelete: 'dagligbank-lokalbank-avtalegiro-proposal-delete',
        proposalUpdate: 'dagligbank-lokalbank-avtalegiro-proposal-update',
        moveAvtalegiros: 'dagligbank-lokalbank-avtalegiro-move',
        moveAvtalegiroError: 'dagligbank-lokalbank-avtalegiro-move-error',
        moveAvtalegiroErrorName: 'dagligbank-lokalbank-avtalegiro-move-try-again',
        createAvtalegiro: 'dagligbank-lokalbank-avtalegiro-create',
    },
    stopped: {
        paymentItem: 'dagligbank-lokalbank-stopped-payment',
        updateStoppedAvtalegiro: 'dagligbank-lokalbank-update-stopped-avtalegiro',
    },
    frontpage: {
        allFuturePaymentsLink: 'dagligbank-lokalbank-all-future-payments-link',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGF5bWVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy91dGlscy9ndG0vdHJhY2tJRHMvcGF5bWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUc7SUFDM0IsTUFBTSxFQUFFLDhCQUE4QjtJQUN0QyxZQUFZLEVBQUUsb0NBQW9DO0lBQ2xELFNBQVMsRUFBRTtRQUNQLFdBQVcsRUFBRSx3Q0FBd0M7UUFDckQsWUFBWSxFQUFFLHlDQUF5QztRQUN2RCxTQUFTLEVBQUUsMENBQTBDO1FBQ3JELE1BQU0sRUFBRSx1Q0FBdUM7UUFDL0MsTUFBTSxFQUFFLHVDQUF1QztRQUMvQyxHQUFHLEVBQUUsb0NBQW9DO0tBQzVDO0lBQ0QsVUFBVSxFQUFFO1FBQ1IsY0FBYyxFQUFFLCtCQUErQjtRQUMvQyxTQUFTLEVBQUUsMkNBQTJDO1FBQ3RELE1BQU0sRUFBRSx3Q0FBd0M7UUFDaEQsTUFBTSxFQUFFLHdDQUF3QztRQUNoRCxZQUFZLEVBQUUsd0NBQXdDO1FBQ3RELGlCQUFpQixFQUFFLG9EQUFvRDtRQUN2RSxjQUFjLEVBQUUsaURBQWlEO1FBQ2pFLGNBQWMsRUFBRSxpREFBaUQ7UUFDakUsZUFBZSxFQUFFLHNDQUFzQztRQUN2RCxtQkFBbUIsRUFBRSw0Q0FBNEM7UUFDakUsdUJBQXVCLEVBQUUsZ0RBQWdEO1FBQ3pFLGdCQUFnQixFQUFFLHdDQUF3QztLQUM3RDtJQUNELE9BQU8sRUFBRTtRQUNMLFdBQVcsRUFBRSxzQ0FBc0M7UUFDbkQsdUJBQXVCLEVBQUUsZ0RBQWdEO0tBQzVFO0lBQ0QsU0FBUyxFQUFFO1FBQ1AscUJBQXFCLEVBQUUsK0NBQStDO0tBQ3pFO0NBQ0osQ0FBQyJ9